export default {
  Usuario: 'Usuario',
  Contraseña: 'Contraseña',
  'Iniciar Sesión': 'Iniciar Sesión',
  '¿Olvidó su contraseña?': '¿Olvidó su contraseña?',
  Recupérala: 'Recupérala',
  Versión: 'Versión',
  BIENVENIDO: 'BIENVENIDO',
  'AGUA DULCE': 'AGUA DULCE',
  'AGUA MAR': 'AGUA MAR',
  Mortalidad: 'Mortalidad',
  'Selecciona un centro': 'Selecciona un centro',
  'Selecciona un módulo': 'Selecciona un módulo',
  MORTALIDAD: 'MORTALIDAD',
  ESTADOS: 'ESTADOS',
  ACCESO: 'ACCESO',
  Hola: 'Hola',
  Usuarios: 'Usuarios',
  '¿No eres': '¿No eres',
  'Cambia de Usuario': 'Cambia de Usuario',
  Siguiente: 'Siguiente',
  'Utiliza al menos 8 caracteres': 'Utiliza al menos 8 caracteres',
  'Este campo es obligatorio': 'Este campo es obligatorio',
  'Introduzca un e-mail valido': 'Introduzca un e-mail valido',
  '¿Has olvidado tu contraseña?': '¿Has olvidado tu contraseña?',
  'RECUPERA TU CUENTA': 'RECUPERA TU CUENTA',
  'Ingresa una dirección de correo electrónico que puedas consultar ahora':
    'Ingresa una dirección de correo electrónico que puedas consultar ahora',
  'Volver a Iniciar Sesión': 'Volver a Iniciar Sesión',
  'Formulario Mortalidad': 'Formulario Mortalidad',
  'Formulario Estados': 'Formulario Estados',
  'Selecciona una piscicultura': 'Selecciona una piscicultura',
  'Selecciona una fecha': 'Selecciona una fecha',
  'Selecciona una sala': 'Selecciona una sala',
  Estanque: 'Estanque',
  ESTANQUE: 'ESTANQUE',
  JAULA: 'JAULA',
  JAULAS: 'JAULAS',
  MODULOS: 'MODULOS',
  'Selecciona una jaula': 'Selecciona una jaula',
  'TIPO DE MORTALIDAD': 'TIPO DE MORTALIDAD',
  'N° DE MORTALIDAD': 'N° DE MORTALIDAD',
  ESTADO: 'ESTADO',
  TIPOS: 'TIPOS',
  'Selecciona el tipo de mortalidad': 'Selecciona el tipo de mortalidad',
  'Buscar Estanque': 'Buscar Estanque',
  'BUSCAR ESTANQUE': 'BUSCAR ESTANQUE',
  'BUSCAR JAULA': 'BUSCAR JAULA',
  BUSCAR: 'BUSCAR',
  ACEPTAR: 'ACEPTAR',
  'Habla ahora': 'Habla ahora',
  'No lo he entendido': 'No lo he entendido',
  'Presione para iniciar': 'Presione para iniciar',
  'Pulsa para pausar': 'Pulsa para pausar',
  'Pulsa para intentarlo de nuevo': 'Pulsa para intentarlo de nuevo',
  'Pulsa para activar microfono': 'Pulsa para activar microfono',
  Si: 'Si',
  Cosecha: 'Cosecha',
  Siembra: 'Siembra',
  'Cambio de Estado.': 'Cambio de Estado.',
  'Nuevo Estado: ': 'Nuevo Estado: ',
  'Estado Actual: ': 'Estado Actual: ',
  'Eliminar registros': 'Eliminar registros',
  '¿Estás seguro de eliminar los registros seleccionados?':
    '¿Estás seguro de eliminar los registros seleccionados?',
  '¿Estás seguro de enviar los registros seleccionados?':
    '¿Estás seguro de enviar los registros seleccionados?',
  Estados: 'Estados',
  'Registro Pendiente: ': 'Registro Pendiente: ',
  'Total de mortalidad ingresada: ': 'Total de mortalidad ingresada: ',
  Enviar: 'Enviar',
  'Fecha de mortalidad: ': 'Fecha de mortalidad: ',
  LABORATORIO: 'LABORATORIO',
  'Todos los Derechos Reservados': 'Todos los Derechos Reservados',
  'Recuperar Contraseña': 'Recuperar Contraseña',
  '¿Ya tiene su contraseña?': '¿Ya tiene su contraseña?',
  'Inicie sesión': 'Inicie sesión',
  Guardar: 'Guardar',
  GUARDAR: 'GUARDAR',
  ENVIAR: 'ENVIAR',
  Guardado: 'Guardado',
  'El registro se guardó con éxito': 'El registro se guardó con éxito',
  'Campo vacio. Ingrese un valor de mortalidad para':
    'Campo vacio. Ingrese un valor de mortalidad para',
  'en fecha': 'en fecha',
  '¡Gracias!': '¡Gracias!',
  'Formulario enviado correctamente': 'Formulario enviado correctamente',
  'VOLVER AL INICIO': 'VOLVER AL INICIO',
  'Cerrar sesión': 'Cerrar sesión',
  '¿Seguro que quieres cerrar sesión?': '¿Seguro que quieres cerrar sesión?',
  Cancelar: 'Cancelar',
  'Formulario de Estados': 'Formulario de Estados',
  'Error al obtener su tipo de perfil. Intente mas tarde.':
    'Error al obtener su tipo de perfil. Intente mas tarde.',
  'ESTADO ACTUAL': 'ESTADO ACTUAL',
  'NUEVO ESTADO': 'NUEVO ESTADO',
  Seleccione: 'Seleccione',
  Prueba: 'Prueba',
  Activo: 'Activo',
  Inactivo: 'Inactivo',
  Manejo: 'Manejo',
  Vacunación: 'Vacunación',
  Recepción: 'Recepción',
  Despacho: 'Despacho',
  Vacío: 'Vacío',
  Reparación: 'Reparación',
  'BUSCAR CENTRO': 'BUSCAR CENTRO',
  'BUSCAR PISCICULTURA': 'BUSCAR PISCICULTURA',
  'Error al enviar la mortalidad. Intente mas tarde.':
    'Error al enviar la mortalidad. Intente mas tarde.',
  'Error al enviar los estados. Intente mas tarde.':
    'Error al enviar los estados. Intente mas tarde.',
  'Ocurrió un error. Intente mas tarde.': 'Ocurrió un error. Intente mas tarde.',
  'Solicitud Exitosa': 'Solicitud Exitosa',
  'Se envió un enlace de recuperación a su correo electrónico. Si no lo recibe en unos segundos revise su bandeja de spam.':
    'Se envió un enlace de recuperación a su correo electrónico. Si no lo recibe en unos segundos revise su bandeja de spam.',
  'Recibirás un correo electrónico con un link para que puedas reestablecer tu contraseña':
    'Recibirás un correo electrónico con un enlace para que puedas restablecer tu contraseña',
  Idioma: 'Idioma',
  'Acabas de reestablecer tu contraseña': 'Acabas de reestablecer tu contraseña',
  'Se envió enlace a ': 'Se envió enlace a ',
  Registros: 'Registros',
  Inglés: 'Inglés',
  Español: 'Español',
  Aceptar: 'Aceptar',
  FORMULARIO: 'FORMULARIO',
  SALAS: 'SALAS',
  ESTANQUES: 'ESTANQUES',
  'Formulario Laboratorio': 'Formulario Laboratorio',
  'Selecciona un estanque': 'Selecciona un estanque',
  'Hora de muestra': 'Hora de muestra',
  'BUSCAR MEDICIONES': 'BUSCAR MEDICIONES',
  'BUSCAR MORTALIDAD': 'BUSCAR MORTALIDAD',
  MEDICIONES: 'MEDICIONES',
  'INGRESA DATOS': 'INGRESA DATOS',
  'Selecciona el area': 'Selecciona el area',
  'Nombre del servicio': 'Nombre del servicio',
  'BUSCAR SERVICIO': 'BUSCAR SERVICIO',
  'Seleccione un trabajo': 'Seleccione un trabajo',
  'Seleccione una faena': 'Seleccione una faena',
  TRABAJOS: 'TRABAJOS',
  TRABAJO: 'TRABAJO',
  'NO TRABAJO': 'NO TRABAJO',
  FAENAS: 'FAENAS',
  Trabajos: 'Trabajos',
  Faenas: 'Faenas',
  Centros: 'Centros',
  'DECLARAR FALLO': 'DECLARAR FALLO',
  OBSERVACIONES: 'OBSERVACIONES',
  Advertencia: 'Advertencia',
  'Ej. Se llevó a cabo con un excelente rendimiento':
    'Ej. Se llevó a cabo con un excelente rendimiento',
  Duplicado: 'Duplicado',
  Embarcación: 'Embarcación',
  Centro: 'Centro',
  Fecha: 'Fecha',
  'Ingresar % de Falla': 'Ingresar % de Falla',
  'Cambiar % de Falla': 'Cambiar % de Falla',
  'No ingresa relevo': 'No ingresa relevo',
  'INGRESAR OTRO SERVICIO': 'INGRESAR OTRO SERVICIO',
  CONTINUAR: 'CONTINUAR',
  'DECLARAR FALLA': 'DECLARAR FALLA',
  DOTACIÓN: 'DOTACIÓN',
  BARCO: 'BARCO',
  BUZO: 'BUZO',
  HIDRÁULICO: 'HIDRÁULICO',
  'Su sesión ha expirado, debe ingresar nuevamente.':
    'Su sesión ha expirado, debe ingresar nuevamente.',
  Enero: 'Enero',
  Febrero: 'Febrero',
  Marzo: 'Marzo',
  Abril: 'Abril',
  Mayo: 'Mayo',
  Junio: 'Junio',
  Julio: 'Julio',
  Agosto: 'Agosto',
  Septiembre: 'Septiembre',
  Octubre: 'Octubre',
  Noviembre: 'Noviembre',
  Diciembre: 'Diciembre',
  'NO SELECCIONAR JAULAS': 'NO SELECCIONAR JAULAS',
  Continuar: 'Continuar',
  'Valida la siguiente información': 'Valida la siguiente información',
  'No uso de ROV': 'No uso de ROV',
  'Uso de ROV': 'Uso de ROV',
  NOMBRE: 'NOMBRE',
  'Seleccionar Todas': 'Seleccionar Todas',
  Alertas: 'Alertas',
  NECROPSIA: 'NECROPSIA',
  'REGISTROS NECROPSIA': 'REGISTROS NECROPSIA',
  'RECEPCIÓN COMBUSTIBLE': 'RECEPCIÓN COMBUSTIBLE',
  'CONSUMO COMBUSTIBLE': 'CONSUMO  COMBUSTIBLE',
  SALUD: 'SALUD',
  LOGISTICA: 'LOGISTICA',
  'Registros necropsia': 'Registros necropsia',
  'Necesitas estar conectado a internet para poder enviar los formularios':
    'Necesitas estar conectado a internet para poder enviar los formularios',
  Resumen: 'Resumen',
  'Foto externa general': 'Foto externa general',
  'Foto interna general': 'Foto interna general',
  'Foto interna branquias': 'Foto interna branquias',
  'Foto adicional': 'Foto adicional',
  'Nueva ficha Necropsia': 'Nueva ficha Necropsia',
  'Comenzar Ficha': 'Comenzar Ficha',
  'FOTO SALMÓN EXTERNA': 'FOTO SALMÓN EXTERNA',
  'Sitúe el pescado completo dentro del margen': 'Sitúe el pescado completo dentro del margen',
  'Foto tomada con éxito': 'Foto tomada con éxito',
  'Repetir foto': 'Repetir foto',
  'FOTO INTERNA BRANQUIAS': 'FOTO INTERNA BRANQUIAS',
  'FOTO INTERNA GENERAL': 'FOTO INTERNA GENERAL',
  'La ficha fue guardada correctamente. ¿Desea crear una nueva ficha?':
    'La ficha fue guardada correctamente. ¿Desea crear una nueva ficha?',
  'FICHA GUARDADA': 'FICHA GUARDADA',
  Terminar: 'Terminar',
  'Crear nueva ficha': 'Crear nueva ficha',
  'FOTO ADICIONAL': 'FOTO ADICIONAL',
  Comentarios: 'Comentarios',
  'Escribe algo o deja un audio': 'Escribe algo o deja un audio',
  Repetir: 'Repetir',
  Salir: 'Salir',
  'Tomar foto': 'Tomar foto',
  'Ficha N': 'Ficha N',
  Hora: 'Hora',
  'Sin internet': 'Sin internet',
  'N° pedido': 'N° pedido',
  'Ingresar pedido manual': 'Ingresar pedido manual',
  'FOTO MEDIDOR FINAL': 'FOTO MEDIDOR FINAL',
  'Llena el estanque de combustible, y cuando hayas terminado, vuelve a tomar otra foto del medidor':
    'Llena el estanque de combustible, y cuando hayas terminado, vuelve a tomar otra foto del medidor',
  'FOTO VARILLA FINAL': 'FOTO VARILLA FINAL',
  'Sitúe punta de la varilla dentro del margen': 'Sitúe punta de la varilla dentro del margen',
  'FOTO MEDIDOR INICIO': 'FOTO MEDIDOR INICIO',
  'Toma una foto del medidor, antes de depositar el combustible.':
    'Toma una foto del medidor, antes de depositar el combustible.',
  'Recepción combustible': 'Recepción combustible',
  'Ingreso pedido manual': 'Ingreso pedido manual',
  'Fecha de entrega': 'Fecha de entrega',
  Proveedor: 'Proveedor',
  Volver: 'Volver',
  'Iniciar prueba de agua': 'Iniciar prueba de agua',
  'Registro medidor final': 'Registro medidor final',
  'Ingrese el número que indica el medidor': 'Ingrese el número que indica el medidor',
  'Resumen recepción combustible': 'Resumen recepción combustible',
  'Varilla inicial': 'Varilla inicial',
  'Varilla final': 'Varilla final',
  'Prueba de agua': 'Prueba de agua',
  'Medidor inicial': 'Medidor inicial',
  'Medidor final': 'Medidor final',
  Registro: 'Registro',
  'Comprobante de entrega': 'Comprobante de entrega',
  'Confirmar recepción': 'Confirmar recepción',
  'Registro Guardado': 'Registro Guardado',
  'Registro Enviado': 'Registro Enviado',
  'Añadir foto': 'Añadir foto',
  'Cantidad de litros': 'Cantidad de litros',
  'Resultado de la prueba': 'Resultado de la prueba',
  'Selecciona positivo si la prueba señala que hay agua en el combustible, y negativo si la prueba señala que no hay agua en el combustible.':
    'Selecciona positivo si la prueba señala que hay agua en el combustible, y negativo si la prueba señala que no hay agua en el combustible.',
  Positivo: 'Positivo',
  Negativo: 'Negativo',
  Enviando: 'Enviando',
  'Ingrese el N° de folio del comprobante': 'Ingrese el N° de folio del comprobante',
  'FOTO COMPROBANTE DE ENTREGA': 'FOTO COMPROBANTE DE ENTREGA',
  'Saque una foto del comprobante de entrega del proveedor':
    'Saque una foto del comprobante de entrega del proveedor',
  'Selecciona un área a monitorear': 'Selecciona un área a monitorear',
  'FOTO VARILLA INICIAL': 'FOTO VARILLA INICIAL',
  Bienvenido: 'Bienvenido',
  Omitir: 'Omitir',
  Recuérdame: 'Recuérdame',
  'Inserta la varilla seca dentro del estanque de combustible, espera 15 segundos y presiona continuar para tomar la siguiente foto.':
    'Inserta la varilla seca dentro del estanque de combustible, espera 15 segundos y presiona continuar para tomar la siguiente foto.',
  'Atención, si la prueba dio positiva, no debes depositar combustible en el estanque, informa a (Nombre encargado y teléfono).':
    'Atención, si la prueba dio positiva, no debes depositar combustible en el estanque, informa a (Nombre encargado y teléfono).',
  Atención: 'Atención',
  Entendido: 'Entendido',
  'Hubo un error al enviar la orden, por favor reintente.':
    'Hubo un error al enviar la orden, por favor reintente.',
  'Seleccione embarcación': 'Seleccione embarcación',
  'Buscar embarcación': 'Buscar embarcación',
  Mon: 'Lun',
  Tue: 'Mar',
  Wed: 'Mié',
  Thu: 'Jue',
  Fri: 'Vie',
  Sat: 'Sáb',
  Sun: 'Dom',
  'Declaración de fallas': 'Declaración de fallas',
  'Seleccione un trabajo y faena': 'Seleccione un trabajo y faena',
}
